// @flow

// Used to inject values into a Stripe Element by using the private API
export const prefillStripeElement = (
  valueName: string,
  valueContent: string,
  element: any,
  delay: number = 0,
) => {
  setTimeout(function() {
    let progress = 0;
    const timer = setInterval(function() {
      const valueContentPartial = valueContent.substring(0, progress++);
      const value = {};
      value[valueName] = valueContentPartial;
      element.update({__privateValue: value});

      if (progress > valueContent.length) {
        clearInterval(timer);
      }
    }, 50);
  }, delay);
};

// Used to inject values into a React input element
export const prefillReactElement = (
  valueContent: string,
  setValueFn: (string) => void,
  delay: number = 0,
) => {
  setTimeout(function() {
    let progress = 0;
    const timer = setInterval(function() {
      const valueContentPartial = valueContent.substring(0, progress++);
      setValueFn(valueContentPartial);

      if (progress > valueContent.length) {
        clearInterval(timer);
      }
    }, 50);
  }, delay);
};
